import React, {Component} from "react";
import PropTypes from "prop-types";
import SimpleFormBuilder from "../forms_builder/SimpleFormBuilder";
import utils from "../../utils/utils";
import Prototypes from "prop-types";
import validationHelper from "../../utils/validationHelper";
import SvGraphics from "../../assets/SvGraphics";
import doctorApi from "../../services/ApiServices/doctorApi";

class PatientEditComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entry: {},
            matrix: [1,1],
            errors: {},
            errorsOnSave: {},
        };
    }

    getFields = () => {
        let {t} = this.props
        return [
            {
                type: 'textarea',
                max: 50,
                name: 'RequestInfo',
                placeholder: '',
                display: '',
                required: false,
                width: 0.6,
                style: 'inline'
            },
            {type:'checkbox', name:'ShowFlag',display: t('hcpLeumitPatientRequests.ShowFlag'), width:1, style:'block'},

        ]
    }


    async componentWillMount() {
        if (this.props && this.props.entry) await this.setState({entry: utils.removeEmptyOrNull(this.props.entry)})
    }

    async closeSideBar() {
        let {t} = this.props
        document.body.style.overflow = "auto"
        this.props.closeSideBar(false)
        this.setState({entry:null})
    }

    async saveInfo() {
        let {t} = this.props
        document.body.style.overflow = "auto"
        let {entry} = this.state
        let response = await doctorApi.EditRequestInfo(entry, entry.UserStorageID)
        if (response) {
            document.body.style.overflow = "auto"
            if(this.props.closeSideBar){
                this.props.closeSideBar(false)
            }
            if(this.props.onValueChange){
                this.props.onValueChange("RequestInfo",entry.RequestInfo)
            }
            if(this.props.editRequest){
                this.props.editRequest(entry)
            }
            this.setState({entry: null})
        }
    }


    onEntryChange = async event => {
        let {entry, validationSchema} = this.state
        let name = event.target.name
        let value = event.target.type === 'checkbox' ?
            !entry[name]
            : event.target.value
        utils.set(entry, name, value)
        let entryValidator = utils.removeEmptyOrNull(entry)
        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }
        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }

    render() {
        let display = this.props.isSideBarOpen ? 'block' : 'none'
        let width = this.props.isSideBarOpen ? "600px" : "0px"
        let container_width = this.props.isSideBarOpen ? "100%" : "0px"
        let {errorsOnSave} = this.state
        let {t} = this.props

        return (
            <div className={"sidenav-complete"} style={{width: container_width, height: "100%"}}>
                <div className={"sidenav"} style={{width: width, height: "100%"}}>
                    <SvGraphics onClick={this.closeSideBar.bind(this)} className={'close-bar-x'} svgname={'close'}
                                height={'15px'} width={'15px'} style={{
                        float: 'left',
                        top: '10px',
                        left: '10px',
                        position: 'absolute',
                        cursor: 'pointer'
                    }}/>
                    <div className={'register-form-title container block'}>
                        <h3 className={'h-centered block'}>{this.props.title}</h3>
                    </div>
                    <div className={'register-form container block'}>
                        <SimpleFormBuilder
                            errors={errorsOnSave}
                            entry={this.state.entry}
                            matrix={this.state.matrix}
                            fields={this.getFields()}
                            onEntryChange={e => this.onEntryChange(e)}
                            onPictureChange={e => this.onPictureChange(e)}
                        />

                    </div>
                    <div className={'register-form-nav-container container block'}
                         style={{display: 'flex', justifyContent: 'space-around'}}>
                        <button type={"button"} onClick={this.closeSideBar.bind(this)} style={{display: display}}
                                className={"btn btn-primary save-info"}>
                            {t('Clinic.form.close')}
                        </button>
                        <button type={"button"} onClick={this.saveInfo.bind(this)} style={{display: display}}
                                className={"btn btn-primary save-info"}>
                            {t('Clinic.form.save')}
                        </button>
                    </div>
                </div>

            </div>
        );
    }
}

PatientEditComment.propTypes = {
    isSideBarOpen: Prototypes.bool.isRequired,
    closeSideBar: Prototypes.func.isRequired,
    title: Prototypes.string.isRequired,
    editRequest: PropTypes.func,
    entry: Prototypes.object
}

export default PatientEditComment

